import { api } from '../DefaultService';
import { IPaginationParams } from '../types';
import {
  ICommunicationCreateProps,
  ICommunicationFilterParams,
  ICommunicationProps,
  ICommunicationSimpleProps,
  ICommunicationUpdateParams,
} from './types';

const ENDPOINT = 'v1/communications';

export const createCommunicationAsync = async (
  data: ICommunicationCreateProps,
): Promise<ICommunicationProps> => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateCommunicationAsync = async ({
  id,
  data,
}: ICommunicationUpdateParams): Promise<ICommunicationProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteCommunicationAsync = async (id: number) => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getCommunicationByIdAsync = async (
  id: number,
): Promise<ICommunicationProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllCommunicationsByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: ICommunicationFilterParams,
): Promise<ICommunicationSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllCommunicationsByLicenseCountAsync = async (
  filter: ICommunicationFilterParams,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, { params: { ...filter } })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
